<template>
  <div class="container-visualPdf">
    <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="true"
        :paginate-elements-by-height="1100"
        filename="HISTORIAL OFTALMOLOGÍA"
        :pdf-quality="2"
        :manual-pagination="true"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="800px"
      ref="html2Pdf"
    >
      <pdf-content slot="pdf-content" :citas = "citas" :appointmentDate="appointmentDate"/>
    </vue-html2pdf>
    <div class="content-date">
      <div
        style="background-color: #6A41BD;
        width: 95px;
        height: 75px;
        display: flex;
        justify-content: center;
        border-radius: 5px;
        "
      >
        <img
          src="../../assets/login-bg.png"
          alt="logo Codet"
          style="width: 75px; height: 75px"
        >
      </div>
      <div class="medical-note">
        <p> {{ $dateString(appointmentDate) }}</p>
      </div>
    </div>
    <div class="table-pdf">
      <el-table
        :data="citas"
        style="width: 100%">
        <el-table-column
          prop="nombrePaciente"
          label="Nombre"
          width="180"
        />
        <el-table-column
          prop="apellidoPaciente"
          label="Apellido"
          width="180"
        />
        <el-table-column
          prop="type"
          label="Tipo de cita"
          width="200"
        />
        <el-table-column
          prop="time"
          label="Hora"
          width="100"
        />
        <el-table-column
          prop="date"
          label="Fecha"
          width="180"
        />
      </el-table>
    </div>
    <br>
    <el-button
      @click="downloadPdf()"
      style="background-color: #6a41bdca; color: #fff; border-radius: 10px"
    >
      Imprimir <i class="el-icon-printer" />
    </el-button>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import VueHtml2pdf from 'vue-html2pdf';
import PdfContent from './printPDF';

export default {
  props: {
    citas: {
      type: Array,
    },
    appointmentDate: {
      type: String,
    },
  },
  data() {
    return {

    };
  },
  components: {
    VueHtml2pdf,
    PdfContent,
  },
  computed: {
    ...mapFields(['controlValue']),
  },
  methods: {
    downloadPdf() {
      this.$refs.html2Pdf.generatePdf();
    },
  },
};
</script>
